'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCampaign = exports.fetchCampaignGroups = exports.fetchCampaign = exports.fetchCampaigns = undefined;

var _client = require('../../../utils/client');

var _justgiving = require('../../../utils/justgiving');

var _params = require('../../../utils/params');

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns(_ref) {
  var ids = _ref.ids;

  if (!ids) {
    return Promise.reject(new Error('This is method only supports an array of GUIDs for JustGiving'));
  }

  return Promise.resolve().then(function () {
    return Array.isArray(ids) ? ids : ids.split(',');
  }).then(function (ids) {
    return Promise.all(ids.map(fetchCampaign));
  });
};

var fetchCampaign = exports.fetchCampaign = function fetchCampaign() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + id).then(function (response) {
    return response.data;
  });
};

var fetchCampaignGroups = exports.fetchCampaignGroups = function fetchCampaignGroups() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return Promise.reject(new Error('This method is not supported for JustGiving'));
};

var deserializeCampaign = exports.deserializeCampaign = function deserializeCampaign(campaign) {
  return {
    charities: campaign.charities,
    donateUrl: [(0, _justgiving.baseUrl)('link'), 'v1/campaign/donate/campaignGuid', campaign.campaignGuid].join('/'),
    eventId: campaign.eventId,
    getStartedUrl: (0, _justgiving.baseUrl)() + '/fundraising-page/creation?campaignGuid=' + campaign.campaignGuid,
    id: campaign.campaignGuid,
    name: campaign.title,
    raised: campaign.donationSummary.totalAmount,
    raisedOffline: campaign.donationSummary.offlineAmount,
    slug: campaign.shortName,
    summary: campaign.summary,
    target: campaign.targetAmount,
    totalDonations: campaign.donationSummary.totalNumberOfDonations,
    url: (0, _justgiving.baseUrl)() + '/campaign/' + campaign.shortName
  };
};